/** Admin bundle detail (edit + purchaser refunds) for one owner. */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../../src/context/OwnerScopeContext';
import BundleDetailScreen from '../../../../../owner/subscriptions/bundle/[id]';

export default function AdminOwnerBundleDetailScreen() {
  const { id, bundleId } = useLocalSearchParams<{ id: string; bundleId: string }>();
  return (
    <OwnerScopeProvider ownerId={id}>
      <BundleDetailScreen entityId={bundleId} />
    </OwnerScopeProvider>
  );
}
